// for global innerHeight of div
const kb_element_wrapper_sections = document.querySelectorAll('.kb-element-wrapper');
const kb_elements = document.querySelectorAll('.kb-element');

kb_element_wrapper_sections.forEach((wrapper) => {
  if (kb_elements.length > 0) {
    const kb_element_height = kb_elements[0].clientHeight;
    wrapper.style.setProperty('--kb-element-height', kb_element_height + 'px');
  }
});

(function ($) {
  // Accordian start
  $(document).ready(function () {
    function kbAccordianToggle() {
      // Select all accordion wrappers
      const kbAccordians = document.querySelectorAll('.kb-accordians-wrapper');

      kbAccordians.forEach((kbAccordian) => {
        const frequentlyQs = kbAccordian.querySelectorAll('.kb-accordian-item');
        const questionTitle = kbAccordian.querySelectorAll('.kb-accordian-header');
        const answerTitle = kbAccordian.querySelectorAll('.kb-accordian-body');

        if (frequentlyQs.length) {
          // Open the first accordion item by default
          // $(frequentlyQs[0]).addClass("kb-accordian-active");
          // $(answerTitle[0]).show();

          // Loop through each accordion header and set click event
          frequentlyQs.forEach((item, i) => {
            $(questionTitle[i]).click(function () {
              answerTitle.forEach((answer, index) => {
                if (i !== index && $(answer).is(':visible')) {
                  $(answer).slideUp(300);
                  $(frequentlyQs[index]).removeClass('kb-accordian-active');
                }
              });

              if ($(answerTitle[i]).is(':hidden')) {
                $(answerTitle[i]).slideDown(300);
                $(item).addClass('kb-accordian-active');
              } else {
                $(answerTitle[i]).slideUp(300);
                $(item).removeClass('kb-accordian-active');
              }
            });
          });
        }
      });
    }

    function kbAccordianOnLoad() {
      kbAccordianToggle();
    }

    window.addEventListener('load', kbAccordianOnLoad);
  });
  // Accordian end
})(jQuery);
